// src/components/auth/ForgotPasswordSuccess.jsx
import { Link, useLocation } from 'react-router-dom';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import ThemeToggle from '../common/ThemeToggle';

const ForgotPasswordSuccess = () => {
  const location = useLocation();
  const email = location.state?.email || 'your email';

  return (
    <div className="min-h-screen flex relative">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="/USIU-Library.jpg"
          alt="USIU-Africa Library"
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-white/95 via-white/90 to-usiu-blue-50/95 dark:from-slate-900/95 dark:via-slate-800/90 dark:to-slate-900/95"></div>
      </div>

      {/* Theme Toggle */}
      <div className="absolute top-6 right-6 z-20">
        <ThemeToggle />
      </div>
      
      {/* Success Container */}
      <div className="flex-1 flex items-center justify-center p-8 relative z-10">
        <div className="max-w-md w-full">
        {/* Success Card */}
        <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-xl border border-gray-100 dark:border-gray-800 p-8 text-center">
          {/* Success Icon */}
          <div className="mx-auto w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mb-6">
            <CheckCircle className="h-8 w-8 text-green-600 dark:text-green-400" />
          </div>
          
          {/* Title */}
          <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-900 to-gray-800 dark:from-usiu-gold-400 dark:to-usiu-gold-500 bg-clip-text text-transparent mb-2">
            Check Your Email
          </h2>
          
          {/* Email Display */}
          <p className="text-gray-600 dark:text-gray-300 mb-6">
            We've sent a password reset link to:
          </p>
          <div className="bg-gray-50 dark:bg-slate-800 rounded-xl px-4 py-3 mb-6">
            <p className="font-medium text-gray-900 dark:text-white flex items-center justify-center gap-2">
              <Mail className="h-4 w-4 text-usiu-blue-500" />
              {email}
            </p>
          </div>
          
          {/* Next Steps */}
          <div className="text-left bg-blue-50 dark:bg-blue-900/20 rounded-xl p-4 mb-6 border border-blue-100 dark:border-blue-800">
            <h3 className="font-semibold text-gray-900 dark:text-white mb-3 text-sm">
              Next Steps:
            </h3>
            <ol className="space-y-2 text-sm text-gray-700 dark:text-gray-300">
              <li className="flex items-start gap-2">
                <span className="font-bold text-usiu-blue-600 dark:text-usiu-blue-400 mt-0.5">1.</span>
                <span>Open your email inbox and look for an email from USIU Counseling</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="font-bold text-usiu-blue-600 dark:text-usiu-blue-400 mt-0.5">2.</span>
                <span>Click the "Reset Password" button in the email</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="font-bold text-usiu-blue-600 dark:text-usiu-blue-400 mt-0.5">3.</span>
                <span>Create a new secure password for your account</span>
              </li>
            </ol>
          </div>
          
          {/* Note */}
          <p className="text-xs text-gray-500 dark:text-gray-400 mb-6">
            Didn't receive the email? Check your spam folder or{' '}
            <Link 
              to="/forgot-password" 
              className="text-usiu-blue-500 hover:text-usiu-blue-600 dark:text-usiu-gold-400 dark:hover:text-usiu-gold-500 font-medium"
            >
              try again
            </Link>
          </p>
          
          {/* Return to Login */}
          <Link 
            to="/login" 
            className="inline-flex items-center justify-center w-full px-4 py-3 bg-usiu-blue-600 hover:bg-usiu-blue-700 text-white font-semibold rounded-xl transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Return to Login
          </Link>
        </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordSuccess;
